import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useEffect } from "react";
import Icon from "@mui/material/Icon";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from  "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import CalendarToday from '@mui/icons-material/CalendarToday';
import SupportAgent from '@mui/icons-material/SupportAgent';
import LockReset from '@mui/icons-material/LockReset';
import Quiz from '@mui/icons-material/Quiz';


function ContactItemList() {
  return (
    <List sx={{ width: '100%'}}>
      <ListItem>
        <ListItemAvatar>
          <Avatar >
            <CalendarToday color="secondary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Schedule A Demo" secondary="See what Prevail has to offer" />
      </ListItem>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <SupportAgent color="secondary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Contact Support" secondary="For customers, our support team is available 24x7" />
      </ListItem>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <LockReset color="secondary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Been Attacked?" secondary="In need of immediate security assistance? Contact us for immediate threat response" />
      </ListItem>      
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <Quiz color="secondary" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Questions?" secondary="For more information on the platform, what we protect, or how we do it" />
      </ListItem>         
    </List>
  )
}

export default function ContactInline() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src='https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        // @TS-ignore
        if (window.hbspt) {
            // @TS-ignore
            window.hbspt.forms.create({
              portalId: "21872696",
              formId: "3e8d1637-816a-43c8-9f28-b7f08ae496fd", 
              target: '#hubspotForm'
            })
        }
    });
  }, []);
  return (
    <Box component="section" py={{ xs: 3, md: 12 }} id="contact" sx={{ zIndex: 1}}>
        <Grid container alignItems="center">
          <Grid item size={{ xs:12, md: 5}} >
            <Typography variant="h3" color="text" pb={5}>
              Contact Us
            </Typography>
            <ContactItemList />
          
            
          </Grid>
          <Grid item size={{ xs:12, md: 5}} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }} >
            <Box
              color="white"
              bgcolor="white"
              variant="gradient"
              shadow="lg"
              opacity={0}
              p={{ xs: 6, md:2 }}
              alignContent="center"
              sx={{ height: {xs: '620px', md: '520px'} }} 
            >
              <div id="hubspotForm" />
          </Box>
          </Grid>
        </Grid>
    </Box>
  );
}

